import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Sprite } from '@pixi/react';
import { menuSectionStore } from '../../../../../store/menuSectionStore';
import { getGameImages } from '../../../../../core/helpers/getGameImages';

const PayTableStepRounds = observer(({ x, y, payTableStepCount }) => {
  const { currentPayTableStepCount } = menuSectionStore;
  const { stepButtonActive, stepButtonInactive } = useMemo(() => {
    return getGameImages();
  }, []);

  return (
    <Container name='PayTableStepRoundsContainer' x={x} y={y}>
      {new Array(payTableStepCount)
        .fill(null)
        .map((_, index) => index)
        .map((key, count) => {
          return (
            <Sprite
              key={key}
              anchor={0.5}
              x={count * 12 + count * 4}
              texture={currentPayTableStepCount === count ? stepButtonActive : stepButtonInactive}
            />
          );
        })}
    </Container>
  );
});

export default PayTableStepRounds;
